import { render, staticRenderFns } from "./SingleEdit.vue?vue&type=template&id=33ea43f7"
import script from "./SingleEdit.vue?vue&type=script&lang=js"
export * from "./SingleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports